import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import {
  checkProxyStatus,
  createPostRequest,
  createGetRequest
} from 'lib/tessitura/common/helpers';

class API {
  constructor(endpoint, initialSessionKey) {
    this.endpoint = endpoint;
    this.sessionKeyProp = 'sessionkey';
    this.initialSessionKey = initialSessionKey || false;
  }
  fetchNewSessionKey() {
    let req = new Request(this.endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'text/plain'
      }),
      body: JSON.stringify({
        method: 'GetNewAnonymousSessionKey',
        params: {}
      })
    });

    return window
      .fetch(req)
      .then(resp => resp.json())
      .then(checkProxyStatus)
      .then(data => data.result);
  }
  getSessionKey() {
    /**
     * If we have already been passed a session to use
     * in the constructor then use that, or if we have
     * one in localStorage use that otherwise go and
     * fetch a new anonymous session key and store
     * *that* value in localStorage.
     */
    if (this.initialSessionKey) {
      return Promise.resolve(this.initialSessionKey);
    }

    let sessionKey;
    try {
      sessionKey = localStorage.getItem(this.sessionKeyProp);
      sessionKey = JSON.parse(sessionKey);
    } catch (e) {} // eslint-disable-line no-empty

    if (sessionKey) {
      return Promise.resolve(sessionKey);
    } else {
      return new Promise(resolve => {
        this.fetchNewSessionKey().then(newSessionKey => {
          if (!sessionKey) {
            try {
              sessionKey = localStorage.setItem(
                this.sessionKeyProp,
                JSON.stringify(newSessionKey)
              );
            } catch (e) {} // eslint-disable-line no-empty
          }
          resolve(newSessionKey);
        });
      });
    }
  }
  request(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createPostRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(resp => resp.json())
        .then(checkProxyStatus);
    });
  }
  requestGet(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createGetRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(resp => resp.json())
        .then(checkProxyStatus);
    });
  }
}

export default API;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/SOAP/tessitura-wrapper.js